type Props = {
  maxValue: number;
};

export const getYAxisTicks = ({ maxValue }: Props): Array<number> => {
  const step = Math.ceil(maxValue / 5);

  const baseTicks = Array.from({ length: 5 }, (_, index) => {
    const currentIndex = index + 1;
    return currentIndex * step;
  });

  if (baseTicks[baseTicks.length - 1] < maxValue) {
    baseTicks.push(Math.ceil(maxValue));
  }

  return [0, ...baseTicks];
};
